// Shared loader utility for displaying a centered spinner with backdrop blur

export function showLoader() {
  hideLoader()

  const backdrop = document.createElement('div')
  backdrop.id = 'app-loader-backdrop'
  backdrop.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(1px);
    -webkit-backdrop-filter: blur(1px);
    z-index: 9998;
  `

  const loader = document.createElement('div')
  loader.id = 'app-loader'
  loader.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
  `
  loader.innerHTML = `
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
      <span class="visually-hidden">Loading...</span>
    </div>
  `

  document.body.appendChild(backdrop)
  document.body.appendChild(loader)
}

export function hideLoader() {
  const loader = document.getElementById('app-loader')
  const backdrop = document.getElementById('app-loader-backdrop')
  if (loader) loader.remove()
  if (backdrop) backdrop.remove()
}
